export const PAGE_SECTIONS = {
  CARD_CAROUSEL: 'pageSectionCardCarousel',
  SHOWCASE: 'sustainabilityPageShowcase',
  COPY: 'sustainabilityPageCopy',
  EMAIL_MODULE: 'pageSectionEmailSignupModule',
};
